import React, { useState, useEffect, useContext } from 'react';
import rawData from './data.json';
import dataExtended from './data-extended.json'
import { Helmet } from 'react-helmet'; // Add this import
import seedrandom from 'seedrandom';

import { AuthContext } from './GameWrapper';






import GameModals from './Modals';

// Set IDs for main data at the start, counting from 1 to 69
const data = rawData.map((game, index) => ({
  ...game,
  id: game.id || (index + 1)  // If game has no ID, use index + 1
}));

function Game() {
    const [gameData, setGameData] = useState([]);
    const [difficulty, setDifficulty] = useState('medium');
    const [unplayedGames, setUnplayedGames] = useState([]);
  const [currentGame, setCurrentGame] = useState(null);
  const [currentGuess, setCurrentGuess] = useState([]);
  const [foundGroups, setFoundGroups] = useState({});
  const [attempts, setAttempts] = useState(4);
  const [message, setMessage] = useState('');
  const [animation, setAnimation] = useState(null);
  const [animationWords, setAnimationWords] = useState([]);
  const [gameOver, setGameOver] = useState(false);
  const [gameId, setGameId] = useState(null); // Add this line
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [selectionStreak, setSelectionStreak] = useState([]);
  const [isArchive, setIsArchive] = useState(false)

  const [gamesPlayedThisSession, setGamesPlayedThisSession] = useState(() => {
    // Check stored data and timestamp
    const storedData = localStorage.getItem('gamesPlayedSession');
    if (storedData) {
      const { count, timestamp } = JSON.parse(storedData);
      const TWO_DAY = 24 * 60 * 60 * 1000 * 2; // 24 hours in milliseconds
      
      // If data is less than 24 hours old, use it; otherwise start fresh
      if (Date.now() - timestamp < TWO_DAY) {
        return count;
      }
    }
    return 0;
  });


  const levelColors = ['#fbd400', '#b5e352', '#729eeb', '#bc70c4'];
  const levelEmojis = ["🔵", "🟢", "🟡", "🔴", "🟣"]; // Choose your own emojis

  const { user, userProgress, saveGameProgress, completeGame, markGameAsPlayed } = useContext(AuthContext);



  const fetchCustomGame = async (customId, slug) => {
    try {
      const param = customId ? `customId=${customId}` : `slug=${slug}`;
      const response = await fetch(`https://gg-apis.vercel.app/custom-connections/game?${param}`);
      const data = await response.json();
      if (response.ok) {
        return data;
      }
    } catch (error) {
      console.error('Error fetching custom game:', error);
    }
    return null;
  };

  useEffect(() => {
    setTimeElapsed(0);  // Reset the timer when starting a new game
  
    // Other codes
  
    const timer = setInterval(() => {
      setTimeElapsed(timeElapsed => timeElapsed + 1);
    }, 1000);
  
    return () => clearInterval(timer);
  }, [gameId]);  // Only depend on gameId




  useEffect(() => {
    if (!user && gameId) {  // Only track for non-logged in users with valid gameId
      const storedData = localStorage.getItem('gamesPlayedSession');
      let currentCount = 0;
      
      if (storedData) {
        const { count, timestamp } = JSON.parse(storedData);
        const ONE_DAY = 24 * 60 * 60 * 1000;
        
        // If data is less than 24 hours old, use it
        if (Date.now() - timestamp < ONE_DAY) {
          currentCount = count + 1;  // Increment the stored count
        }
      } else {
        currentCount = 1;  // First game
      }

      // Store updated count
      localStorage.setItem('gamesPlayedSession', JSON.stringify({
        count: currentCount,
        timestamp: Date.now()
      }));

      console.log(currentCount)

      // Only show login after second game
      if (currentCount === 2) {
        const loginBtn = document.getElementById('login-button');
        if (loginBtn) {
          loginBtn.click();
        }
      }
    }
  }, [gameId, user]);  // Depend on gameId and user

  
  
  const shuffleArray = (array) => {
    let currentIndex = array.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  };
  
  

  useEffect(() => {
    setGameData(data);
    setTimeElapsed(0);
    setUnplayedGames([...Array(data.length).keys()]);
    let gameIndex;
  
    const urlParams = new URLSearchParams(window.location.search);
    const gameId = urlParams.get('gameId');
    const archive = urlParams.get('archive');
    const customId = urlParams.get('customId');
    const customSlug = urlParams.get('custom');
    setGameId(gameId);
  
    const loadGame = async () => {
      if (customId || customSlug) {
        const customGame = await fetchCustomGame(customId, customSlug);
        if (customGame) {
          setCurrentGame(customGame);
          return;
        }
      }
    
     
    
      let gameToLoad;
    
      if(gameId) {
        // Try to find game in main data
        if (gameId < 10000) {
          gameToLoad = data.find(g => g.id === parseInt(gameId));
        } 
        // Try to find in extended data
        else {
          const extendedIndex = parseInt(gameId) - 10000;
          gameToLoad = dataExtended[extendedIndex];
          if (gameToLoad) {
            gameToLoad = { ...gameToLoad, id: parseInt(gameId) };
          }

          setDifficulty(gameToLoad.difficulty || 'medium');
        }
    
        // If game not found, load daily game
        if (!gameToLoad) {
          gameIndex = generateIndexConnections();
          gameToLoad = data[gameIndex];
        }
      } else {
        if(archive) {
          
          setIsArchive(true);
          gameIndex = generateIndexConnections(archive) % data.length;
          gameToLoad = data[gameIndex];
          setGameId(gameToLoad.id);
        } else {
          gameIndex = generateIndexConnections() % data.length;
          gameToLoad = data[gameIndex];
        }
      }
    
      setCurrentGame(gameToLoad);
    };
    
    const startNewGame = () => {
      // Get today's game index using existing function
      const todayIndex = generateIndexConnections();
      
      // Get past games excluding today and future games
      const availableMainGames = data.filter(game => game.id < todayIndex);
      
      // Map extended games with IDs
      const extendedGamesWithIds = dataExtended.map((game, index) => ({
        ...game,
        id: 10000 + index
      }));
      
      // Merge both sets of games
      const allAvailableGames = [...availableMainGames, ...extendedGamesWithIds];
      
      // Filter out games the user has already played
      const playedGames = userProgress?.completedGames || [];
      const unplayedGames = allAvailableGames.filter(game => !playedGames.includes(game.id));
    
      if (unplayedGames.length === 0) {
        setMessage('You have played all available games!');
        return;
      }
      
      // Pick a random unplayed game
      const randomIndex = Math.floor(Math.random() * unplayedGames.length);
      const newGameId = unplayedGames[randomIndex].id;
    
      // Redirect to new game
      window.location.href = window.location.origin + '?gameId=' + newGameId;
    };
  
    loadGame();
    setSelectionStreak([]);
  }, [gameId]);


  // Add this component inside Game function
const MarkAsPlayedButton = () => {
  const gameIdentifier = gameId || currentGame?.id;
  const [marked, setMarked] = useState(false);


  if (!gameId && !isArchive) {
    return null;
   }

   if( !user )
      return null;

  const handleMark = async () => {
    if (gameIdentifier && !marked) {
      await markGameAsPlayed(parseInt(gameIdentifier));
      setMarked(true);
      setMessage('Game marked as played');
    }
  };

  // Don't show button if game is already completed or marked
  if (!gameIdentifier || 
      userProgress?.completedGames?.includes(parseInt(gameIdentifier)) || 
      userProgress?.markedAsPlayed?.includes(parseInt(gameIdentifier))) {
    return null;
  }



  return (
    <button 
      className="game-btn" 
      onClick={handleMark}
      disabled={marked}
      style={{ width:'100%' }}
    >
      {marked ? 'Marked as Played' : 'Mark as Played'}
    </button>
  );
};

const changeDifficulty = (newDifficulty) => {
  const availableGamesWithDifficulty = dataExtended.filter(game => 
    game.difficulty === newDifficulty || 
    (newDifficulty === 'easy' && !game.difficulty)
  );
  
  // If we have games with this difficulty, select one randomly
  if (availableGamesWithDifficulty.length > 0) {
    const randomIndex = Math.floor(Math.random() * availableGamesWithDifficulty.length);
    const selectedGame = availableGamesWithDifficulty[randomIndex];
    const gameId = 10000 + dataExtended.indexOf(selectedGame);
    window.location.href = window.location.origin + '?gameId=' + gameId;
  } else {
    // If no games with this difficulty, pick a random game from dataExtended
    const randomIndex = Math.floor(Math.random() * dataExtended.length);
    const gameId = 10000 + randomIndex;
    window.location.href = window.location.origin + '?gameId=' + gameId;
  }
};

  const changeArchive = (newArchive) => {
    const formattedDate = `${newArchive.getMonth()+1}/${newArchive.getDate()}/${newArchive.getFullYear()}`;
    window.location.href = `${window.location.origin}?archive=${formattedDate}`;
  }

  // Update the URL to include new archive date
  

  function getDatesBetween(start, end) {
    let startDate = new Date(start);
    let endDate = new Date(end);
    let dates = [];
    while(startDate <= endDate) {
        dates.push(new Date(startDate));
        startDate.setDate(startDate.getDate() + 1);
    }
    return dates.reverse(); // reverse to get from today back to 6/12/2023
}

  function generateIndexConnections(archive) {
    const D = 864e5;
    const e = new Date("6/12/2023");
    let t = false;
    let today = new Date();
    today.setHours(0, 0, 0, 0);
  
    if( archive ) {
      let archiveDate = new Date(archive);
      archiveDate.setHours(0, 0, 0, 0);

      // If the archive date is after today's date, throw an error
      if( archiveDate.getTime() > today.getTime() ) {
        t = today - e.setHours(0, 0, 0, 0);
      }
      else {
        t = archiveDate - e.setHours(0, 0, 0, 0);
      }
    }
    else {
      t = today - e.setHours(0, 0, 0, 0);
    }
    
    let n = Math.round(t / D);
    return n < 0 ? Math.abs(n) : n;
  }

  const handleWordClick = word => {
    // If the word is already selected, remove it from the currentGuess
    if (currentGuess.includes(word)) {
      setCurrentGuess(currentGuess.filter(guess => guess !== word));
    } 
    // Else if there are less than 4 items in the currentGuess, add the word
    else if (currentGuess.length < 4) {
      setCurrentGuess([...currentGuess, word]);
    } 
    // If there are 4 items already and the word isn't one of them, ignore the click
    else {
      return;
    }
  };

  
  

  const submitGuess = () => {
    if (currentGuess.length !== 4) {
        setMessage('You need to select 4 items before submitting');
        return;
      }
      console.log(currentGame)
      const guessedGroup = Object.entries(currentGame.groups).find(
        ([groupName, group]) =>
          JSON.stringify(group.members.sort()) === JSON.stringify(currentGuess.sort())
      );

    if (guessedGroup) {
      setFoundGroups({
        ...foundGroups,
        [guessedGroup[0]]: guessedGroup[1].members,
      });

      const newStartingGroups = currentGame.startingGroups
        .flat()
        .filter(word => !currentGuess.includes(word));

      setCurrentGame({
        ...currentGame,
        startingGroups: chunkArray(newStartingGroups, 4),
      });
      
      setMessage('Congratulations! You have found a group!');
        setAnimation('success');
        setAnimationWords(currentGuess);
        setTimeout(() => {
            setCurrentGuess([]);
            setAnimation(null);
            setAnimationWords([]);
        }, 1000);
    } else {
        setAnimation('error');
        setAnimationWords(currentGuess);
        setTimeout(() => {
            setAnimation(null);
            setAnimationWords([]);
        }, 1000);
      setMessage('Incorrect guess, please try again');
        setAttempts(prevAttempts => {
          if(prevAttempts - 1 === 0) {
              setGameOver(true);
              setMessage('Game Over! All attempts used up!');
              // Only count failure if it wasn't already completed
              if (!userProgress?.completedGames?.includes(Number(gameId))) {
                  completeGame(gameId, false);
              }
          }
          return prevAttempts - 1;
      });
    }

    const wordLevels = currentGuess.map((word) => {
      // Find the group to which the word belongs
      const groupName = Object.keys(currentGame.groups).find(
        key => currentGame.groups[key].members.includes(word)
      );
    
      // Get the level of this group
      const level = currentGame.groups[groupName].level;
    
      // Return the word and its corresponding level
      return { word, level };
    });
  
    setSelectionStreak([...selectionStreak, wordLevels]);
  };

  const startNewGame = () => {
    const todayIndex = generateIndexConnections();
    const availableMainGames = data.filter(game => game.id < todayIndex);
    const extendedGamesWithIds = dataExtended.map((game, index) => ({
      ...game,
      id: 10000 + index
    }));
    
    const allAvailableGames = [...availableMainGames, ...extendedGamesWithIds];
    
    // Filter out both completed and marked games
    const playedGames = [
      ...(userProgress?.completedGames || []),
      ...(userProgress?.markedAsPlayed || [])
    ];
    const unplayedGames = allAvailableGames.filter(game => !playedGames.includes(game.id));
  
    if (unplayedGames.length === 0) {
      setMessage('You have played all available games!');
      return;
    }
    
    const randomIndex = Math.floor(Math.random() * unplayedGames.length);
    const newGameId = unplayedGames[randomIndex].id;
  
    window.location.href = window.location.origin + '?gameId=' + newGameId;
  };

  const restartGame = () => {
    window.location.reload();
  };

  const resetGuess = () => {
    setCurrentGuess([]);
  };

  const copyResultsToClipboard = () => {
    // Create a string from the selection streak
    const resultsString = selectionStreak.map((guess, index) => 
      guess.map((wordObj) => `${levelEmojis[wordObj.level]}`).join('')
    ).join('');
    window.focus();
    // Copy the string to the clipboard
    navigator.clipboard.writeText('ConnectionsUnlimited.org - ' + resultsString).then(function(){
      alert('Copied to Clipboard, you can now share the result in social media.');
    });
    // Show an alert message
  };

  
  const archiveDates = getDatesBetween("6/12/2023", new Date())

  useEffect(() => {
    const gameIdentifier = gameId || currentGame?.id;
    
    if (currentGame && 
        Object.keys(foundGroups).length === Object.keys(currentGame.groups).length && 
        gameIdentifier) {
        // Check if this game was already completed
        if (!userProgress?.completedGames?.includes(Number(gameIdentifier))) {
            completeGame(gameIdentifier, true);
            console.log('completed game');
        } else {
            console.log('game already completed before, not counting for streak');
        }
    }
}, [foundGroups, currentGame, gameId]);

  return (
    <>
    <GameModals />
    { /*<div className="ad-bar">Try this <a href="https://www.nflgrid.org/" target="_blank">Play NFL Grid Wordle!</a> 🎮</div> */ }
    
    
    
      {gameId && (
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
      )}
        <Helmet>
        <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "Organization",
            "@id": "https://www.connectionsunlimited.org/#organization",
            "name": "Connections Unlimited",
            "url": "https://www.connectionsunlimited.org/"
          },
          {
            "@type": "WebSite",
            "@id": "https://www.connectionsunlimited.org/#website",
            "url": "https://www.connectionsunlimited.org/",
            "name": "Connections Unlimited",
            "publisher": {
              "@id": "https://www.connectionsunlimited.org/#organization"
            }
          }
        ]
      }
    `}
  </script>
        </Helmet>
       
        {Object.entries(foundGroups).map(([groupName, words], index) => (
        <div
          className="game-group"
          key={groupName}
          style={{ backgroundColor: levelColors[index % levelColors.length] }}
        >
          <h3 className="group-name">{groupName}</h3>
          <div className="group-members">{words.join(', ')}</div>
        </div>
      ))}

<div className="top-g">
  <p className="p-text">
    {gameId && !isArchive && (
      <>
        <strong>Connections Unlimited #{gameId}</strong>
      </>
    )}
    {(!gameId && !currentGame?.title) || isArchive && (
      <span>Create four groups of four.</span>
    )}
    {/* Move isArchive check out of the badge condition */}
    {currentGame && userProgress?.completedGames?.includes(Number(gameId || currentGame?.id)) && (
      <span className="replay-badge" style={{ marginLeft: isArchive ? '0' : '10px' }}>
        🔄 Completed
      </span>
    )}
  </p>
  <div className="game-time">Time: {`${Math.floor(timeElapsed / 60).toString().padStart(2, '0')}:${(timeElapsed % 60).toString().padStart(2, '0')}`}</div>
</div>

{currentGame && (currentGame.title || currentGame.author) && (
  <div className="custom-game-info">
    <h2 className="custom-game-title">{currentGame.title}</h2>
    <p className="custom-game-author">Created by {currentGame.author}</p>
  </div>
)}
      

      {currentGame && currentGame.startingGroups.map((group, groupIndex) => (
        <div className="game-board" key={groupIndex}>
          {group.map((word, wordIndex) => (
            <button
            className={`game-item 
              ${currentGuess.includes(word) ? 'selected' : ''} 
              ${animationWords.includes(word) ? `${animation}-animation` : ''} 
              ${word.length === 8 ? 'size-8' : ''} 
              ${word.length > 8 ? 'size-more' : ''}`}
            key={wordIndex}
            onClick={() => handleWordClick(word)}
          >
            {word || ' '}
          </button>
          
          ))}
        </div>
      ))}
      {message && <div className="message">{message}</div>}
      <div className="game-attempts">Mistakes remaining: {attempts}</div>
      {gameOver ? (
        <>
          <button className="game-btn" onClick={restartGame}>Restart the same Game</button>
          <a 
          className="game-btn" 
          href="#" 
          onClick={(e) => {
            e.preventDefault();
            startNewGame();
          }}
          role="button"
          aria-pressed="false">Start New Game</a>
        </>
      ) : (
        <>
          {currentGame && Object.keys(foundGroups).length === Object.keys(currentGame.groups).length ? (
            <>
                
                <div className="congratulations">
                    <h2>Congratulations!</h2>
                    <p>You have found all groups!</p>
                    <div className="share">
  {selectionStreak.map((guess, index) => (
    <div key={index} className="share-row">
      {guess.map((wordObj, i) => (
        <span key={i} style={{ backgroundColor: levelColors[wordObj.level] }}>
          
        </span>
      ))}
    </div>
  ))}
</div>
<button className="game-btn" style={{ backgroundColor:'#000000', color:'#fff', marginTop:'10px' }} onClick={copyResultsToClipboard}>Share Results</button>
                </div>
                <a 
                  className="game-btn" 
                  href="#" 
                  onClick={(e) => {
                    e.preventDefault();
                    startNewGame();
                  }}
                  role="button"
                  aria-pressed="false">Start New Game</a>
            </>
        
          ) : (
            <>
            <div className="btn-wrapper">
              <button className="game-btn submit-btn" onClick={submitGuess}>Submit</button>
              <button className="game-btn" onClick={resetGuess}>Deselect</button>
              
              <a 
                className="game-btn" 
                href="#" 
                onClick={(e) => {
                  e.preventDefault();
                  startNewGame();
                }}
                role="button"
                aria-pressed="false">New Game</a>
                <MarkAsPlayedButton />
            </div>
            
            </>
          )}

          {!isArchive && !currentGame?.title && (
            <div className="difficulty-wrapper">
              <button 
                onClick={() => changeDifficulty('easy')} 
                className={difficulty === 'easy' ? 'selected' : ''}
              >
                Easy
              </button>
              <button 
                onClick={() => changeDifficulty('medium')} 
                className={difficulty === 'medium' ? 'selected' : ''}
              >
                Medium
              </button>
              <button 
                onClick={() => changeDifficulty('hard')} 
                className={difficulty === 'hard' ? 'selected' : ''}
              >
                Hard
              </button>
            </div>
          )}
          
          { !currentGame?.title && (
          <div className="archive-wrapper">
                <select 
                    onChange={e => changeArchive(new Date(e.target.value))} 
                >

                    <option key="" value="">--Select an archive date--</option>

                    {archiveDates.map(date => {
                        const formattedDate = `${date.getMonth()+1}/${date.getDate()}/${date.getFullYear()}`;
                        return (
                            <option key={formattedDate} value={formattedDate}>
                                {formattedDate}
                            </option>
                        )
                    })}
                </select>
          </div>
          )}
            
        </>
      )}
      
    
    </>
  );
}

function chunkArray(array, size) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

export default Game;